import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  transition: height 0.25s ease-in-out;\n  height: ", "px;\n  position: relative;\n  width: 100%;\n  z-index: 3;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Component } from 'react';
import styled, { ThemeProvider } from 'styled-components';
var Wrapper = styled.div(_templateObject());
var NavigationAndContent = styled.div(_templateObject2());
var BannerContainer = styled.div(_templateObject3(), function (props) {
  return props.isBannerOpen ? props.bannerHeight : 0;
});
var Banner = styled.div(_templateObject4());
var Navigation = styled.div(_templateObject5());
var PageContent = styled.div(_templateObject6());
var emptyTheme = {};

var Page = /*#__PURE__*/function (_Component) {
  _inherits(Page, _Component);

  var _super = _createSuper(Page);

  function Page() {
    _classCallCheck(this, Page);

    return _super.apply(this, arguments);
  }

  _createClass(Page, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isBannerOpen = _this$props.isBannerOpen,
          banner = _this$props.banner,
          navigation = _this$props.navigation,
          children = _this$props.children,
          bannerHeight = _this$props.bannerHeight;
      return /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: emptyTheme
      }, /*#__PURE__*/React.createElement(Wrapper, null, this.props.banner ? /*#__PURE__*/React.createElement(BannerContainer, {
        "aria-hidden": !isBannerOpen,
        isBannerOpen: isBannerOpen,
        bannerHeight: bannerHeight
      }, /*#__PURE__*/React.createElement(Banner, null, banner)) : null, /*#__PURE__*/React.createElement(NavigationAndContent, null, /*#__PURE__*/React.createElement(Navigation, null, navigation), /*#__PURE__*/React.createElement(PageContent, null, children))));
    }
  }]);

  return Page;
}(Component);

_defineProperty(Page, "displayName", 'AkPage');

_defineProperty(Page, "defaultProps", {
  isBannerOpen: false,
  bannerHeight: 52
});

export { Page as default };